import '../../scss/utilities/animation.scss';
/**
 * All currently supported animations
 */
export var Animations;
(function (Animations) {
    Animations["Default"] = "bp-u-animation";
    Animations["Flip"] = "bp-u-animation_flip";
    Animations["Grow"] = "bp-u-animation_grow";
})(Animations || (Animations = {}));
